import * as yup from 'yup';
import isEmailValidator from 'validator/es/lib/isEmail';
import { isVenueAndUserFromNorthAmerica } from '~/utils/venue';
import { mandatoryField } from '~/utils/featureToggle';
import { FieldMandatory } from '~/types/common';
import { fullNameSchema, mobileSchema } from '~/utils/validation';
const FULLNAME_MANDATORY = mandatoryField(FieldMandatory.fullname_mandatory);
const EMAIL_MANDATORY = mandatoryField(FieldMandatory.email_mandatory);
const MOBILE_MANDATORY = mandatoryField(FieldMandatory.mobile_mandatory);
const RELATIONSHIP_MANDATORY = mandatoryField(FieldMandatory.relationship_mandatory);
const POSTCODE_MANDATORY = mandatoryField(FieldMandatory.postcode_mandatory);
export default (country) => yup.object({
    fullName: FULLNAME_MANDATORY
        ? fullNameSchema.required('Name is required')
        : fullNameSchema,
    email: EMAIL_MANDATORY
        ? yup
            .string()
            .email('Please provide a valid email address')
            .required('Email is required')
            .test('is-valid', (message) => `${message.path} is invalid`, (value) => value
            ? process.env.NODE_ENV === 'test'
                ? true
                : isEmailValidator(value)
            : new yup.ValidationError('Please provide a valid email address'))
        : yup
            .string()
            .email('Please provide a valid email address')
            .test('is-valid', (message) => `${message.path} is invalid`, (value) => value ? (process.env.NODE_ENV === 'test' ? true : isEmailValidator(value)) : true),
    mobileCountry: yup.string().default(country),
    mobile: MOBILE_MANDATORY
        ? mobileSchema(true)
        : mobileSchema(false).optional(),
    relationship: RELATIONSHIP_MANDATORY
        ? yup.string().required('Relationship is required')
        : yup.string().optional(),
    zip: isVenueAndUserFromNorthAmerica(country) || POSTCODE_MANDATORY
        ? yup
            .string()
            .trim()
            .required(country === 'US' ? 'Zip Code is required' : 'Postcode is required')
        : yup.string().trim().optional(),
    tandc: yup
        .bool()
        .oneOf([true], 'Please agree to the T&C and Privacy Policy')
        .required('Please agree to the T&C and Privacy Policy'),
});
